module.exports = __webpack_public_path__ + "img/docs.ebc3ea0f.png";